import { render, staticRenderFns } from "./messageTemplateDetail.vue?vue&type=template&id=f3b6542e"
import script from "./messageTemplateDetail.vue?vue&type=script&lang=js"
export * from "./messageTemplateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports